import React, { useContext, useState, useEffect } from 'react'
import funride from '../../lib/funride/funride.module.less'
import ManagersContext from '../../containers/ManagersContext'
const titleCss =
  'color:#000000; font-size:13px; font-family:Verdana, Arial, Helvetica, sans-serif; overflow:hidden; font-weight: normal;line-height: 19px;'

export default function InnerPageMusic() {
  const { objMusic } = useContext(ManagersContext)
  const aPhotos = objMusic.photoAlbum.photos.reduce(
    (accum: React.ReactNode[], photo, i) => {
      if (i > 3) {
        accum.push(
          <a
            key={`photo_${i}`}
            href={require('' + photo.image)}
            data-width={photo.width}
            data-height={photo.height}
            data-thumbwidth="150"
            data-thumbheight="150"
            data-shownavigation="false"
            data-autoslide="true"
            className="html5lightbox"
            data-group="set4"
            title={photo.description}
          />
        )
      }
      return accum
    },
    []
  )
  const [albumPhotos, setAlbumPhotos] = useState<React.ReactNode[]>(aPhotos)
  useEffect(() => {
    // Below fixes problem: on first click of a youtube video, page was taken over by youtube.com, then
    // when back-buttoning and clicking on youtube video, it properly displayed in carousel
    /* eslint-disable @typescript-eslint/no-explicit-any */
    const wwindow = window as any // "window.$" gets typescript error.  Solution found here: https://bit.ly/3q8zmHO
    wwindow.$('.html5lightbox').html5lightbox()
  }, [])

  return (
    <div>
      <header>
        <h1>Music</h1>
        <p>
          I've been playing music since I was 12. Here's a sampling of some
          things I've done over the years.
        </p>
      </header>
      <dl className={funride.musicVideo}>
        <dt>Original Compositions</dt>
        <dd>
          {/*TO DO Revisit why it is necessary to use require() for images, why not use an import?*/}
          <a
            href="https://www.youtube.com/watch?v=eRdt_8D0CoM"
            data-thumbnail={require('./resources/images/compositions/easterThursdayThumb.png')}
            className="html5lightbox"
            data-group="set1"
            data-width="600"
            data-showplaybutton="false"
            data-shownavigation="false"
            data-titlecss={titleCss}
            data-titleprefix="Greg Sandell - "
            data-thumbwidth="150"
            data-thumbheight="150"
            data-height="400"
            title="Variations on 'Easter Thursday' for Piano"
          >
            <img
              src={require('./resources/images/compositions/easterThursdayThumb.png')}
            />
          </a>
          <a
            href="https://youtu.be/wZWgard4hfw"
            data-thumbnail={require('./resources/images/compositions/freshJuliepiesThumb.png')}
            className="html5lightbox"
            data-group="set1"
            title="Fresh Juliepies for Piano"
            data-showplaybutton="false"
            data-shownavigation="false"
          >
            <img
              src={require('./resources/images/compositions/freshJuliepiesThumb.png')}
            />
          </a>
          <a
            href="https://www.youtube.com/watch?v=jS6V7Cp28xM"
            data-thumbnail={require('./resources/images/compositions/studyInFifthsThumb.png')}
            className="html5lightbox"
            data-group="set1"
            title="Study in Fifths for Piano"
            data-showplaybutton="false"
            data-shownavigation="false"
          >
            <img
              src={require('./resources/images/compositions/studyInFifthsThumb.png')}
            />
          </a>
          <div className={funride.moreMusic}>
            <a
              href="https://www.youtube.com/watch?v=lQDWg72tmRc"
              className="html5lightbox"
              data-group="set1"
              title="Jesse's Pig for Jazz Ensemble"
              style={{ fontStyle: 'italic' }}
              data-showplaybutton="false"
              data-shownavigation="false"
            >
              More...
            </a>
          </div>
          <div className={funride.hiddenSlides}>
            <a
              href="https://www.youtube.com/watch?v=AaLeoEUCB1M"
              className="html5lightbox"
              data-group="set1"
              title="Cayman Island Dream"
            />
            <a
              href="https://youtu.be/DyK3oSXxnSQ"
              className="html5lightbox"
              data-group="set1"
              title="Quartet for Violin, Clarinet, Cello and Piano"
            />
            <a
              href="https://youtu.be/oSyXpuarmKU"
              className="html5lightbox"
              data-group="set1"
              title="Pomona College (piano introduction)"
            />
            <a
              href="https://youtu.be/t4txAVCQkEQ"
              className="html5lightbox"
              data-group="set1"
              title="Gavotte for Piano"
            />
            <a
              href="https://youtu.be/8CYdG9FrzVw"
              className="html5lightbox"
              data-group="set1"
              title="Study in Fifths No. 2 for Piano"
            />
            <a
              href="https://youtu.be/QjIfyvMVBAQ"
              className="html5lightbox"
              data-group="set1"
              title="The Guitar for Baritone and Piano"
            />
          </div>
        </dd>
        <dt>Danse ce Soir - Book and CD</dt>
        <dd>
          <a
            href="http://www.melbay.com/Products/98118/danse-ce-soir--fiddle-and-accordion-music-of-quebec.aspx"
            data-thumbnail={require('./resources/images/danseCeSoir/bookThumb.png')}
            className="html5lightbox"
            data-group="set2"
            data-width="600"
            data-showplaybutton="false"
            data-shownavigation="false"
            data-titlecss={titleCss}
            data-titleprefix="Danse ce Soir - "
            data-thumbwidth="150"
            data-thumbheight="150"
            data-height="400"
            title="Mel Bay publication of Danse ce Soir"
          >
            <img
              src={require('./resources/images/danseCeSoir/bookThumb.png')}
            />
          </a>
          <a
            href="https://www.youtube.com/watch?v=4RZhzRSFPdw"
            data-thumbnail={require('./resources/images/danseCeSoir/danseLaurieGregThumb.png')}
            className="html5lightbox"
            data-group="set2"
            title="Clog à Ti-Jules"
            data-showplaybutton="false"
            data-shownavigation="false"
          >
            <img
              src={require('./resources/images/danseCeSoir/danseLaurieGregThumb.png')}
            />
          </a>
          <a
            href="https://www.youtube.com/watch?v=nmO8cnnQ4UI"
            data-thumbnail={require('./resources/images/danseCeSoir/mixingBoardThumb.jpg')}
            className="html5lightbox"
            data-group="set2"
            title="Fisher's Hornpipe"
            data-showplaybutton="false"
            data-shownavigation="false"
          >
            <img
              src={require('./resources/images/danseCeSoir/mixingBoardThumb.jpg')}
            />
          </a>
          <div className={funride.moreMusic}>
            <a
              href="https://www.youtube.com/watch?v=PGHktw6G_-g"
              className="html5lightbox"
              data-group="set2"
              title="Valse du mois d'novembre"
              style={{ fontStyle: 'italic' }}
              data-showplaybutton="false"
              data-shownavigation="false"
            >
              More...
            </a>
          </div>
          <div className={funride.hiddenSlides}>
            <a
              href="https://www.youtube.com/watch?v=zl2CONkYDl0"
              className="html5lightbox"
              data-group="set2"
              title="Gigue du père Mathias/Reel St-Jean/Reel Joseph"
            />
            <a
              href="https://www.youtube.com/watch?v=eKVAGmSOJww"
              className="html5lightbox"
              data-group="set2"
              title="6/8 en sol/Valcartier Set"
            />
            <a
              href="https://www.youtube.com/watch?v=w12csU0vr68"
              className="html5lightbox"
              data-group="set2"
              title="Reel des poilus/Reel du pendu"
            />
            <a
              href="https://www.youtube.com/watch?v=87Uyo2tSMR8"
              className="html5lightbox"
              data-group="set2"
              title="Marche au camp/Reel en la"
            />
            <a
              href="https://www.youtube.com/watch?v=KtBJfAs7yX4"
              className="html5lightbox"
              data-group="set2"
              title="Première partie du lancier/Saut du lapin/Air du Saguenay"
            />
            <a
              href="https://www.youtube.com/watch?v=vGA_Ki0EK54"
              className="html5lightbox"
              title="Le violon confesseur"
            />
            <a
              href="https://www.youtube.com/watch?v=MIXYs91NGH8"
              className="html5lightbox"
              data-group="set2"
              title="Danse du barbier/Cotillon de Baie-Ste-Catherine/La marmotteuse"
            />
            <a
              href="https://www.youtube.com/watch?v=vUzLc1A20h4"
              className="html5lightbox"
              data-group="set2"
              title="Valse-clog Guilmette/Valse-clog Lacroix"
            />
            <a
              href="https://www.youtube.com/watch?v=ch7Q_7Fs9Ew"
              className="html5lightbox"
              data-group="set2"
              title="Galope à Denis/La ronde des voyageurs"
            />
            <a
              href="https://www.youtube.com/watch?v=p4SaiZjKixI"
              className="html5lightbox"
              data-group="set2"
              title="6/8 en ré/Gigue des capouchons"
            />
            <a
              href="https://www.youtube.com/watch?v=zdXvxYsghyQ"
              className="html5lightbox"
              data-group="set2"
              title="Galope de la Malbaie/Eugène/Mackilmoyle's Reel"
            />
            <a
              href="https://www.youtube.com/watch?v=0gc8vOENWT4"
              className="html5lightbox"
              data-group="set2"
              title="La veuve du pendu"
            />
            <a
              href="https://www.youtube.com/watch?v=p_BMjFVsokg"
              className="html5lightbox"
              data-group="set2"
              title="Valse du vieux moulin"
            />
            <a
              href="https://www.youtube.com/watch?v=zYRzW_bcdKA"
              className="html5lightbox"
              data-group="set2"
              title="La grande gigue simple"
            />
          </div>
        </dd>
        <dt>Fool's Gold - Klezmer Band</dt>
        <dd>
          <a
            href="http://gregsandell.blogspot.com/2017/08/remembering-fools-gold.html"
            data-thumbnail={require('./resources/images/foolsGold/cassetteCoverThumb.png')}
            className="html5lightbox"
            data-group="set5"
            data-width="1000"
            data-showplaybutton="false"
            data-shownavigation="false"
            data-titlecss={titleCss}
            data-thumbwidth="150"
            data-thumbheight="150"
            data-height="600"
            title="Remembering Fool's Gold (blog)"
          >
            <img
              src={require('./resources/images/foolsGold/cassetteCoverThumb.png')}
            />
          </a>
          <a
            href="https://youtu.be/KPOX63F_mF8"
            data-thumbnail={require('./resources/images/foolsGold/bandNameThumb.png')}
            className="html5lightbox"
            data-group="set5"
            data-width="600"
            data-showplaybutton="false"
            data-shownavigation="false"
            data-titlecss={titleCss}
            data-thumbwidth="150"
            data-thumbheight="150"
            data-height="400"
            title="Di Zilberne Khasene - Fool's Gold"
          >
            <img
              src={require('./resources/images/foolsGold/bandNameThumb.png')}
            />
          </a>
          <a
            href="https://www.youtube.com/watch?v=aTy5UdAWa4Y"
            data-thumbnail={require('./resources/images/foolsGold/coupleThumb.png')}
            className="html5lightbox"
            data-group="set5"
            data-width="600"
            data-showplaybutton="false"
            data-shownavigation="false"
            data-titlecss={titleCss}
            data-thumbwidth="150"
            data-thumbheight="150"
            data-height="400"
            title="Moriah & Bishop Street - Fool's Gold"
          >
            <img
              src={require('./resources/images/foolsGold/coupleThumb.png')}
            />
          </a>
          <div className={funride.moreMusic}>
            <a
              href="https://www.youtube.com/watch?v=adfIXotKEUo"
              className="html5lightbox"
              data-group="set5"
              title="Bird in Hand Jig - Ellis Island - Eddie's Reel - Moishe's Reel"
              style={{ fontStyle: 'italic' }}
              data-showplaybutton="false"
              data-shownavigation="false"
            >
              More...
            </a>
          </div>
          <div className={funride.hiddenSlides}>
            <a
              href="https://www.youtube.com/watch?v=8BDDEXuR8g0"
              className="html5lightbox"
              data-group="set5"
              title="Air for Guitar - Fool's Gold"
            />
            <a
              href="https://www.youtube.com/watch?v=Cyvz7b8qSlg"
              className="html5lightbox"
              data-group="set5"
              title="Polka Mazurka - Fool's Gold"
            />
            <a
              href="https://www.youtube.com/watch?v=Cyvz7b8qSlg"
              className="html5lightbox"
              data-group="set5"
              title="Polka Mazurka - Fool's Gold"
            />
            <a
              href="https://www.youtube.com/watch?v=lv-pbbu3m6I"
              className="html5lightbox"
              data-group="set5"
              title="Old Grey Cat - Sheyn Vi Di l'Vone - Amaranth - Fool's Gold"
            />
            <a
              href="https://www.youtube.com/watch?v=gUJh6XX7ybY"
              className="html5lightbox"
              data-group="set5"
              title="Korobushka / Skrip, Klezmerl, Skrip  - Fool's Gold"
            />
            <a
              href="https://www.youtube.com/watch?v=Zcbeb9jFD14"
              className="html5lightbox"
              data-group="set5"
              title="Ukrainer Dance   - Fool's Gold"
            />
            <a
              href="https://www.youtube.com/watch?v=UWESCer4fa0"
              className="html5lightbox"
              data-group="set5"
              title="Ragtime Annie - Drums & Guns - Dancing Bear - Fool's Gold"
            />
            <a
              href="https://www.youtube.com/watch?v=N6lFVRgG3Q8"
              className="html5lightbox"
              data-group="set5"
              title="Ukrainer Chosid'l - Fool's Gold"
            />
            <a
              href="https://www.youtube.com/watch?v=GoVJBl46itg"
              className="html5lightbox"
              data-group="set5"
              title="Merry Blacksmith - Cooley's Reel - Fool's Gold"
            />
            <a
              href="https://www.youtube.com/watch?v=VHqVxUKnJaU"
              className="html5lightbox"
              data-group="set5"
              title="Morrison's Jig - Spootiskerry - Zog Farvos? - Fool's Gold"
            />
            <a
              href="https://www.youtube.com/watch?v=clt153rQq3w"
              className="html5lightbox"
              data-group="set5"
              title="La Despedida - Fool's Gold"
            />
          </div>
        </dd>
        <dt>Transcriptions</dt>
        <dd>
          <a
            href="https://youtu.be/cMLs7Aemmpk"
            data-thumbnail={require('./resources/images/transcriptions/zappaSofaThumb.png')}
            className="html5lightbox"
            data-group="set3"
            data-width="600"
            data-showplaybutton="false"
            data-shownavigation="false"
            data-titlecss={titleCss}
            data-thumbwidth="150"
            data-thumbheight="150"
            data-height="400"
            title="Sofa by Frank Zappa, arranged for Piano"
          >
            <img
              src={require('./resources/images/transcriptions/zappaSofaThumb.png')}
            />
          </a>
          <a
            href="https://www.youtube.com/watch?v=ykTRZgApGuc"
            data-thumbnail={require('./resources/images/transcriptions/mclaughlinNoReturnThumb.png')}
            className="html5lightbox"
            data-group="set3"
            title="No Return by John McLaughlin"
            data-showplaybutton="false"
            data-shownavigation="false"
          >
            <img
              src={require('./resources/images/transcriptions/mclaughlinNoReturnThumb.png')}
            />
          </a>
          <a
            href="https://www.youtube.com/watch?v=9Brpi0JvnwY"
            data-thumbnail={require('./resources/images/transcriptions/lizStoryBradleysDreamThumb.png')}
            className="html5lightbox"
            data-group="set3"
            title="Bradley's Dream by Liz Story (transcribed by Greg Sandell)"
            data-showplaybutton="false"
            data-shownavigation="false"
          >
            <img
              src={require('./resources/images/transcriptions/lizStoryBradleysDreamThumb.png')}
            />
          </a>
          <div className={funride.moreMusic}>
            <a
              href="https://youtu.be/54qjtWOXd4I"
              className="html5lightbox"
              data-group="set3"
              title="Yet to Be by Oregon (transcribed by Greg Sandell"
              style={{ fontStyle: 'italic' }}
              data-showplaybutton="false"
              data-shownavigation="false"
            >
              More...
            </a>
          </div>
          <div className={funride.hiddenSlides}>
            <a
              href="https://youtu.be/yfLd0Jyj6vI"
              className="html5lightbox"
              data-group="set3"
              title="U Kruševo Ogin Gori (Macedonia, trad), transcribed by Greg Sandell"
            />
            <a
              href="https://youtu.be/kYjJp5ys3lI"
              className="html5lightbox"
              data-group="set3"
              title="Uncle Remus piano intro, transcribed by Greg Sandell"
            />
            <a
              href="https://youtu.be/sPyhMHonEIU"
              className="html5lightbox"
              data-group="set3"
              title="It Must Be a Camel by Frank Zappa, transcribed by Greg Sandell"
            />
            <a
              href="https://youtu.be/bQWmV3CKmqs"
              className="html5lightbox"
              data-group="set3"
              title="Twenty Small Cigars by Frank Zappa, transcribed by Greg Sandell"
            />
            <a
              href="https://youtu.be/FNVJwJCilHk"
              className="html5lightbox"
              data-group="set3"
              title="Hope by Mahavishnu Orchestra, transcribed by Greg Sandell"
            />
            <a
              href="https://youtu.be/c_GB26wd3OI"
              className="html5lightbox"
              data-group="set3"
              title="A Remark You Made, by Joe Zawinul (Weather Report)"
            />
          </div>
        </dd>
        <dt>Solo Piano</dt>
        <dd>
          <a
            href="https://youtu.be/F11taBw-cKI"
            data-thumbnail={require('./resources/images/pianoSolo/totentanzThumb.png')}
            className="html5lightbox"
            data-group="set7"
            data-width="600"
            data-showplaybutton="false"
            data-shownavigation="false"
            data-titlecss={titleCss}
            data-thumbwidth="150"
            data-thumbheight="150"
            data-height="400"
            title="Franz Liszt - Totentanz"
          >
            <img
              src={require('./resources/images/pianoSolo/totentanzThumb.png')}
            />
          </a>
          <a
            href="https://youtu.be/ZadaRN5bcyg"
            data-thumbnail={require('./resources/images/pianoSolo/prokofievThumb.png')}
            className="html5lightbox"
            data-group="set7"
            title="Serge Prokofiev - Piano Sonata No 3"
            data-showplaybutton="false"
            data-shownavigation="false"
          >
            <img
              src={require('./resources/images/pianoSolo/prokofievThumb.png')}
            />
          </a>
          <a
            href="https://youtu.be/kf0nULaEHLg"
            data-thumbnail={require('./resources/images/pianoSolo/bergThumb.png')}
            className="html5lightbox"
            data-group="set7"
            title="Alban Berg - Sonata Op 1"
            data-showplaybutton="false"
            data-shownavigation="false"
          >
            <img src={require('./resources/images/pianoSolo/bergThumb.png')} />
          </a>
          <div className={funride.moreMusic}>
            <a
              href="https://youtu.be/VPeczkE75LQ"
              className="html5lightbox"
              data-group="set7"
              style={{ fontStyle: 'italic' }}
              title="Chopin - Ballade No 3 in Ab Op 47"
            >
              More...
            </a>
          </div>
          <div className={funride.hiddenSlides}>
            <a
              href="https://youtu.be/e1w22tyB2ig"
              className="html5lightbox"
              data-group="set7"
              title="Brahms: Intermezzo Op 118 No 2"
            />
            <a
              href="https://youtu.be/dRTEBsILVOs"
              className="html5lightbox"
              data-group="set7"
              title="J.S. Bach - Prelude & Fugue in F#"
            />
          </div>
        </dd>
        <dt>Misc Recordings</dt>
        <dd>
          <a
            href="https://youtu.be/O4UUT4yHYyA"
            data-thumbnail={require('./resources/images/miscRecordings/gravityHill.jpg')}
            className="html5lightbox"
            data-group="set6"
            data-width="600"
            data-showplaybutton="false"
            data-shownavigation="false"
            data-titlecss={titleCss}
            data-thumbwidth="150"
            data-thumbheight="150"
            data-height="400"
            title="Le Bal des Accordéons - Carnaval"
          >
            <img
              src={require('./resources/images/miscRecordings/gravityHill.jpg')}
            />
          </a>
          <a
            href="https://youtu.be/bV_VlF-r66w"
            data-thumbnail={require('./resources/images/miscRecordings/dancingAndDreaming.jpg')}
            className="html5lightbox"
            data-group="set6"
            title="Flowers of Edinburgh - Becky's Breakthrough"
            data-showplaybutton="false"
            data-shownavigation="false"
          >
            <img
              src={require('./resources/images/miscRecordings/dancingAndDreaming.jpg')}
            />
          </a>
          <a
            href="https://youtu.be/MSRbNpl3dMY"
            data-thumbnail={require('./resources/images/miscRecordings/dancingAndDreaming.jpg')}
            className="html5lightbox"
            data-group="set6"
            title="Rosie's Waltz"
            data-showplaybutton="false"
            data-shownavigation="false"
          >
            <img
              src={require('./resources/images/miscRecordings/dancingAndDreaming.jpg')}
            />
          </a>
        </dd>
        <dt>Photos From a Lifetime of Music</dt>
        <dd>
          <a
            // href='/static/media/01a_daMuseum.270a5ed0199faf71225b.png'
            href={require('' + objMusic.photoAlbum.photos[0].image)}
            data-thumbnail={require('./resources/images/playingMusic/daMuseumThumb.png')}
            className="html5lightbox"
            data-group="set4"
            data-width={objMusic.photoAlbum.photos[0].width}
            data-height={objMusic.photoAlbum.photos[0].height}
            data-titlecss={titleCss}
            data-thumbwidth="150"
            data-thumbheight="150"
            data-autoslide="true"
            data-shownavigation="false"
            title={objMusic.photoAlbum.photos[0].description}
          >
            <img
              src={require('./resources/images/playingMusic/daMuseumThumb.png')}
            />
          </a>
          <a
            href={require('' + objMusic.photoAlbum.photos[1].image)}
            data-thumbnail={require('./resources/images/playingMusic/flourocarbonsMoogThumb.png')}
            className="html5lightbox"
            data-group="set4"
            data-shownavigation="false"
            data-autoslide="true"
            data-titlecss={titleCss}
            data-width={objMusic.photoAlbum.photos[1].width}
            data-height={objMusic.photoAlbum.photos[1].height}
            data-thumbwidth="150"
            data-thumbheight="150"
            title={objMusic.photoAlbum.photos[1].description}
          >
            <img
              src={require('./resources/images/playingMusic/flourocarbonsMoogThumb.png')}
            />
          </a>
          <a
            href={require('' + objMusic.photoAlbum.photos[2].image)}
            data-thumbnail={require('./resources/images/playingMusic/gregAccordionThumb.png')}
            className="html5lightbox"
            data-group="set4"
            data-shownavigation="false"
            data-autoslide="true"
            data-width={objMusic.photoAlbum.photos[2].width}
            data-height={objMusic.photoAlbum.photos[2].height}
            title={objMusic.photoAlbum.photos[2].description}
          >
            <img
              src={require('./resources/images/playingMusic/gregAccordionThumb.png')}
            />
          </a>
          <div className={funride.moreMusic}>
            <a
              href={require('' + objMusic.photoAlbum.photos[3].image)}
              data-width={objMusic.photoAlbum.photos[3].width}
              data-height={objMusic.photoAlbum.photos[3].height}
              data-shownavigation="false"
              data-autoslide="true"
              style={{ fontStyle: 'italic' }}
              className="html5lightbox"
              data-group="set4"
              title={objMusic.photoAlbum.photos[3].description}
            >
              More...
            </a>
          </div>
          <div className={funride.hiddenSlides}>{albumPhotos}</div>
        </dd>
      </dl>
    </div>
  )
}
